import React from 'react'
import PropTypes from 'prop-types'
import { CatalogCurrencyLabel } from 'Shared/CurrencyLabel'

const MileageSection = ({
  mileage,
  pointsValue,
  mileagePoints,
  fidelityNumber,
  currencyConfiguration,
  fidelityLabel
}) => (
  <div className='col-12 txt-left justify-content-center align-self-center row mx-0'>
    <p className='col-12 mx-0 px-0 txt-body-sm txt-subtitle txt-font-body color-ui-2'>
      Transferência: <strong>{mileage || 'Selecione o parceiro'}</strong>
    </p>
    <p className='col-12 mx-0 px-0 txt-body-sm txt-font-body color-ui-2'>
      Valor em {currencyConfiguration.pointsName}:{' '}
      <CatalogCurrencyLabel value={pointsValue || 0} />
    </p>
  </div>
)

MileageSection.propTypes = {
  mileage: PropTypes.string,
  pointsValue: PropTypes.string,
  mileagePoints: PropTypes.number,
  fidelityNumber: PropTypes.number,
  currencyConfiguration: PropTypes.object,
  fidelityLabel: PropTypes.string
}

export default MileageSection



// WEBPACK FOOTER //
// ./src/features/MileageRescue/Sidebar/MileageSection.js